import React from 'react';
import classNames from 'classnames';
import { Formik } from 'formik';
import { Alert, Forms, CollapsibleText } from '../../platformui';

const Form = (props) => {
  const validate = (values) => {
    const errors = {};

    if (!values[QuestionField.Name].trim()) {
      errors[QuestionField.Name] = 'required';
    }
    if (!values[AgeField.Name]) {
      errors[AgeField.Name] = 'required';
    }
    if (!values[RegionField.Name]) {
      errors[RegionField.Name] = 'required';
    }
    if (!values[GenderField.Options[0].Name]) {
      errors[GenderField.Options[0].Name] = 'required';
    }
    return errors;
  };

  const serviceIsClosed = !props.QuestionData.Form.ServiceIsOpen;
  const form = React.useRef(null);

  const {
    QuestionField,
    AliasField,
    AgeField,
    RegionField,
    GenderField,
    SubmitButton,
    ErrorMessage,
  } = props.QuestionData.Form;

  //Set up error messages
  const errorMessages = {};
  errorMessages['prefix'] = props.Translations.fix;
  errorMessages['required'] = props.Translations.isrequired;
  errorMessages['email'] = props.Translations.notvalidemail;

  const getValueFromOptions = (options) => {
    let arr = options.filter((o) => o.Selected === true);

    return arr.length > 0 ? arr[0].Value : '';
  };
  const initialValues = {
    [QuestionField.Name]: QuestionField.Value || '',
    [AliasField.Name]: AliasField.Value || '',
    [AgeField.Name]: AgeField.Value || '',
    [RegionField.Name]: RegionField.Value || '',
    [GenderField.Options[0].Name]: getValueFromOptions(GenderField.Options),
  };
  return (
    <div className="c-create-question" data-cy="ui-isopen">
      <div dangerouslySetInnerHTML={{ __html: props.ServiceInformation }}></div>
      <CollapsibleText
        buttonReadMoreText={props.ReadMoreText}
        buttonReadLessText={props.ReadLessText}
        heading={props.FormHeading}
        Modifiers={{ 'show-icon': true }}
      >
        <div dangerouslySetInnerHTML={{ __html: props.ServiceTerms }}></div>
      </CollapsibleText>

      {ErrorMessage && <Alert type="warning">{ErrorMessage}</Alert>}
      {!serviceIsClosed && props.QuestionData.Form && (
        <Formik
          onSubmit={() => form.current.submit()}
          validateOnChange={true}
          validateOnBlur={true}
          validate={validate}
          initialValues={initialValues}
        >
          {(formik) => (
            <form
              onSubmit={formik.handleSubmit}
              ref={form}
              noValidate={true}
              method="post"
              className="c-forms"
            >
              <div className="row">
                <div className="columns">
                  <Forms.Field
                    component="textarea"
                    name={QuestionField.Name}
                    className="c-forms__textarea"
                    required={true}
                    maxLength={2000}
                    maxLengthTranslation={QuestionField.MaxLengthTranslation}
                    label={QuestionField.Label}
                    errorType={formik.errors[QuestionField.Name]}
                    errorMessages={errorMessages}
                    isValid={!formik.errors[QuestionField.Name]}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values[QuestionField.Name]}
                    isTouched={formik.touched[QuestionField.Name]}
                  >
                    <Forms.Label
                      className={classNames({
                        'c-forms__label': true,
                        'c-forms__label--inline': true,
                      })}
                      required={true}
                      label={QuestionField.Label}
                      htmlFor={QuestionField.Name}
                    />
                  </Forms.Field>
                </div>
              </div>

              <div className="row">
                <div className="medium-5 columns">
                  <Forms.Label
                    className="c-forms__label"
                    label={AliasField.Label}
                    htmlFor={AliasField.Name}
                    required={false}
                  />

                  <Forms.Field
                    component="input"
                    className="c-forms__input"
                    type="text"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values[AliasField.Name]}
                    required={false}
                    name={AliasField.Name}
                    label={AliasField.Label}
                    isValid={true}
                    isTouched={formik.touched[AliasField.Name]}
                  />
                </div>

                <div className="medium-3 columns">
                  <Forms.Label
                    className="c-forms__label c-forms__label--hidden"
                    label={AgeField.Label}
                    htmlFor={AgeField.Name}
                    required={true}
                  />

                  <Forms.Field
                    component="select"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    name={AgeField.Name}
                    className="c-forms__select"
                    label={AgeField.Label}
                    value={formik.values[AgeField.Name]}
                    required={true}
                    errorMessages={errorMessages}
                    errorType={formik.errors[AgeField.Name]}
                    isValid={!formik.errors[AgeField.Name]}
                    isTouched={formik.touched[AgeField.Name]}
                  >
                    <option value="">{AgeField.Label}*</option>
                    {AgeField.Options.map((option, key) => (
                      <option key={key} value={option.Value}>
                        {option.Label}
                      </option>
                    ))}
                  </Forms.Field>
                </div>

                <div className="medium-4 columns">
                  <Forms.Label
                    className="c-forms__label c-forms__label--hidden"
                    label={RegionField.Label}
                    htmlFor={RegionField.Name}
                    required={true}
                  />

                  <Forms.Field
                    component="select"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    name={RegionField.Name}
                    className="c-forms__select"
                    label={RegionField.Label}
                    value={formik.values[RegionField.Name]}
                    required={true}
                    errorMessages={errorMessages}
                    errorType={formik.errors[RegionField.Name]}
                    isValid={!formik.errors[RegionField.Name]}
                    isTouched={formik.touched[RegionField.Name]}
                  >
                    <option value="">{RegionField.Label}*</option>
                    {RegionField.Options.map((option, key) => (
                      <option key={key} value={option.Value}>
                        {option.Label}
                      </option>
                    ))}
                  </Forms.Field>
                </div>
              </div>

              <div className="row">
                <div className="columns">
                  <Forms.Radio>
                    <Forms.Label
                      required={true}
                      label={GenderField.Label}
                      className="c-forms__label"
                    />
                    {GenderField.Options.map((option, key) => (
                      <label
                        key={key}
                        className="c-forms__radio c-forms__radio--button"
                      >
                        <input
                          type="radio"
                          name={option.Name}
                          defaultValue={option.Value}
                          defaultChecked={option.Selected}
                          onChange={formik.handleChange}
                        />
                        <span>{option.Label}</span>
                      </label>
                    ))}
                  </Forms.Radio>
                  <Forms.Error
                    isError={
                      formik.errors[GenderField.Options[0].Name] &&
                      formik.touched[GenderField.Options[0].Name]
                    }
                    errorMessages={errorMessages}
                    errorType="required"
                  />
                </div>
              </div>

              <div className="row">
                <div className="columns">
                  <div className="c-forms__submit-container">
                    <Forms.Button
                      className="c-forms__button"
                      type="submit"
                      canSubmit={true}
                    >
                      {SubmitButton.Label}
                    </Forms.Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default Form;
